import "./index.css";
import React, { Fragment } from "react";
import ContentBlock from "../ContentBlock";
import { brandedBannerContent } from "../../constants";

export default function BrandedBanner() {
  return (
    <Fragment>
      <div className="branded-banner branded-banner--mobile">
        <ContentBlock contentObj={brandedBannerContent[2]} i={1} />
        <ContentBlock contentObj={brandedBannerContent[0]} i={2} />
        <ContentBlock contentObj={brandedBannerContent[1]} i={3} />
        <ContentBlock contentObj={brandedBannerContent[3]} i={4} />
      </div>
      <div className="branded-banner branded-banner--desktop">
        <div className="branded-banner__container">
          <ContentBlock contentObj={brandedBannerContent[0]} i={3} />
          <ContentBlock contentObj={brandedBannerContent[1]} i={4} />
        </div>
        <div className="branded-banner__container">
          <ContentBlock contentObj={brandedBannerContent[2]} i={1} />
          <ContentBlock contentObj={brandedBannerContent[3]} i={2} />
        </div>
      </div>
    </Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/screens/AdminRegistration/components/BrandedBanner/index.js